// 調證文件上傳頁面翻譯
export default {
  title: "調證文件",
  buttons: {
    upload: "上傳調證",
    reset: "重置",
    query: "查詢",
  },
  placeholders: {
    fileName: "請輸入調證文件名稱",
    caseName: "請輸入案件名稱",
    platform: "請選擇調證平台",
    parseResult: "請選擇解析結果",
    uploader: "請輸入上傳人",
    startDate: "開始日期",
    endDate: "結束日期",
  },
  total: {
    prefix: "共計",
    suffix: "條數據",
  },
  guide: {
    uploadTip: "點擊可上傳解析您的調證文件",
  },
  messages: {
    uploadSuccess: "上傳調證成功",
  },
  table: {
    loading: "拼命加載中",
    columns: {
      evidenceFile: "調證文件",
      case: "案件",
      platform: "平台",
      parseResult: "解析結果",
      uploader: "上傳人",
      uploadTime: "上傳時間",
      operation: "操作",
    },
    actions: {
      download: "下載",
      downloading: "下載中...",
    },
    noData: "--",
  },
};
